import qs from 'query-string';

import { getEnvVar } from './env';
import { parseNilOrValue } from './fns';
import * as Urls from '../constants/Urls';

export const mapLegacyRoute = (route = '') => {
  switch (route) {
    case 'EntityDisplay.aspx': {
      return Urls.ENTITY_DISPLAY;
    }
    case 'WorkflowStep.aspx': {
      return Urls.WORKFLOW_STEP;
    }
    case 'EntityEdit.aspx': {
      return Urls.MASTER_SETUP_PAGE;
    }
    default:
      return route;
  }
};

const urlParams = [
  'itmId',
  'entityType',
  'formKey',
  'stepId',
  'workflowId',
  'containerWorkflowKey',
  'parentWorkflowId',
  'workflowKey',
  'actionName',
  'taskId',
];

export function mapUrlParams(
  params,
  { ignoreUnknownParams = true, ignoreEmptyValues = true } = {}
) {
  return Object.keys(params).reduce((acc, key) => {
    const value = params[key];

    if (!value && ignoreEmptyValues) {
      return acc;
    }

    let param = urlParams.find((param) => new RegExp(`^${param}$`, 'i').test(key));

    if (!param) {
      if (ignoreUnknownParams) {
        return acc;
      }

      param = key.substr(0, 1).toLowerCase() + key.substr(1);
    }

    return { ...acc, [param]: value };
  }, {});
}

export function parseNavigationColumnParams(url) {
  const [page, queryString] = url.split('?');

  const isLegacyRoute =
    page.includes('EntityDisplay.aspx') ||
    page.includes('WorkflowStep.aspx') ||
    page.includes('EntityEdit.aspx');

  let pathname = isLegacyRoute ? mapLegacyRoute(page.split('/').pop()) : page;

  if (!pathname.startsWith('/')) {
    pathname = `/${pathname}`;
  }

  if (pathname.includes('.aspx')) {
    const token = parseNilOrValue(localStorage.getItem('token'));
    const adminAppUrl = getEnvVar('REACT_APP_ADMIN_APP_URL');
    const fullPathname = `${adminAppUrl}${pathname}`;
    const fullSearch = [queryString?.replaceAll('amp;', ''), `Token=${token}`]
      .filter(Boolean)
      .join('&');

    return {
      pathname: fullPathname,
      search: fullSearch,
      url: `${fullPathname}?${fullSearch}`,
    };
  }

  const legacyParams = qs.parse(queryString.replace(/&amp;/g, '&'));

  const newParams = mapUrlParams(legacyParams, {
    ignoreUnknownParams: false,
    ignoreEmptyValues: false,
  });

  const search = qs.stringify(newParams);

  return {
    pathname,
    search,
    url: `${pathname}?${search}`,
  };
}

export function parseLegacyURL(url = '') {
  const match = url.match(/.*?'(.+?)'.*?/);
  return parseNavigationColumnParams(match ? match[1] : url);
}
